const lang = localStorage.getItem("language");
const state = () => ({
  localeConfig: lang || process.env.VUE_APP_LOCALE
});

const mutations = {
  setLocale(state, locale) {
    state.localeConfig = locale;
  }
};

const actions = {
  switchLanguage(context, locale) {
    context.commit("setLocale", locale);
    window.location.reload();
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
